(function () {
  'use strict';

  /* Single instance — prevent double-load from section + theme.liquid */
  if (window.ssWishlist) return;

  var KEY = 'ss_wishlist';
  var LEGACY_KEYS = ['wishlist', 'smoke_shop_wishlist'];
  var CACHE_KEY = 'ss_wishlist_cache_v1';
  var renderGen = 0;
  var removing = Object.create(null);

  function cacheGet(handle) {
    try {
      var all = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
      return all[handle] || null;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(handle, product) {
    try {
      var all = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
      all[handle] = {
        id: product.id,
        handle: product.handle,
        title: product.title,
        vendor: product.vendor,
        price: product.price,
        featured_image: product.featured_image || (product.images && product.images[0]) || '',
        variants: product.variants
      };
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(all));
    } catch (e) {}
  }

  function skeletonCard() {
    return (
      '<article class="ss-pcard ss-wishlist__skeleton" aria-hidden="true">' +
      '<div class="ss-pcard__media-wrap" style="background:#ececec;min-height:180px;"></div>' +
      '<div class="ss-pcard__body">' +
      '<div style="height:12px;width:40%;background:#ececec;border-radius:6px;margin-bottom:8px;"></div>' +
      '<div style="height:16px;width:90%;background:#ececec;border-radius:6px;margin-bottom:8px;"></div>' +
      '<div style="height:16px;width:30%;background:#ececec;border-radius:6px;"></div>' +
      '</div></article>'
    );
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw !== null && raw !== undefined) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
      }
      for (var i = 0; i < LEGACY_KEYS.length; i++) {
        var legacy = localStorage.getItem(LEGACY_KEYS[i]);
        if (!legacy) continue;
        var list = JSON.parse(legacy);
        if (Array.isArray(list)) {
          write(list, true);
          return list;
        }
      }
    } catch (e) {}
    return [];
  }

  function write(handles, silent) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles));
      for (var i = 0; i < LEGACY_KEYS.length; i++) {
        localStorage.removeItem(LEGACY_KEYS[i]);
      }
    } catch (e) {}
    if (!silent) {
      document.dispatchEvent(new CustomEvent('ss:wishlist-updated', { detail: { handles: handles } }));
    }
  }

  function toggle(handle) {
    if (!handle) return read();
    var list = read();
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    write(list);
    return list;
  }

  function isSaved(handle) {
    return read().indexOf(handle) !== -1;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function getHandleFromButton(btn) {
    var card = btn.closest('[data-product-handle]');
    if (card) return card.getAttribute('data-product-handle');
    return btn.getAttribute('data-product-handle');
  }

  function syncHeaderBadge() {
    var badge = document.querySelector('[data-ss-wishlist-badge]');
    if (!badge) return;
    var count = read().length;
    badge.textContent = String(count);
    badge.hidden = count < 1;
  }

  function syncButtons() {
    document.querySelectorAll('[data-ss-wishlist]').forEach(function (btn) {
      var handle = getHandleFromButton(btn);
      if (!handle) return;
      var saved = isSaved(handle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    });
    syncHeaderBadge();
  }

  function updateToolbar(root, count) {
    var countEl = root.querySelector('[data-ss-wishlist-count]');
    var toolbar = root.querySelector('[data-ss-wishlist-toolbar]');
    if (countEl) {
      countEl.textContent = count + ' saved item' + (count === 1 ? '' : 's');
    }
    if (toolbar) toolbar.hidden = count === 0;
  }

  function pulseHeart(btn) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    btn.classList.remove('ss-wish-pulse');
    void btn.offsetWidth;
    btn.classList.add('ss-wish-pulse');
    setTimeout(function () { btn.classList.remove('ss-wish-pulse'); }, 280);
  }

  function removeCardOptimistic(handle) {
    var root = document.querySelector('[data-ss-wishlist-page]');
    if (!root) return;
    var card = root.querySelector('[data-product-handle="' + handle + '"]');
    if (card) {
      card.classList.add('ss-wishlist__card--leaving');
      setTimeout(function () {
        if (card.parentNode) card.parentNode.removeChild(card);
        var remaining = read().length;
        updateToolbar(root, remaining);
        syncHeaderBadge();
        if (remaining === 0) {
          var grid = root.querySelector('[data-ss-wishlist-grid]');
          var empty = root.querySelector('[data-ss-wishlist-empty]');
          if (grid) {
            grid.innerHTML = '';
            grid.hidden = true;
          }
          if (empty) empty.hidden = false;
        }
      }, 180);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = getHandleFromButton(btn);
    if (!handle) return;
    if (removing[handle]) return;

    var wasSaved = isSaved(handle);
    removing[handle] = true;
    btn.disabled = true;

    /* Optimistic UI on wishlist page remove */
    if (wasSaved && document.querySelector('[data-ss-wishlist-page]')) {
      toggle(handle);
      syncButtons();
      removeCardOptimistic(handle);
      removing[handle] = false;
      btn.disabled = false;
      return;
    }

    var list = toggle(handle);
    var nowSaved = list.indexOf(handle) !== -1;
    syncButtons();
    if (nowSaved) {
      pulseHeart(btn);
      /* Prefetch product JSON into session cache for instant wishlist page */
      try {
        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (shopRoot.slice(-1) !== '/') shopRoot += '/';
        fetch(shopRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { if (p) cacheSet(handle, p); })
          .catch(function () {});
      } catch (err) {}
    }
    removing[handle] = false;
    btn.disabled = false;
  });

  function renderPage() {
    var root = document.querySelector('[data-ss-wishlist-page]');
    if (!root) return;

    var gen = ++renderGen;
    var grid = root.querySelector('[data-ss-wishlist-grid]');
    var empty = root.querySelector('[data-ss-wishlist-empty]');
    var handles = read();

    updateToolbar(root, handles.length);
    syncHeaderBadge();

    if (!handles.length) {
      if (grid) {
        grid.hidden = true;
        grid.innerHTML = '';
      }
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    if (grid) {
      grid.hidden = false;
      /* Keep existing cards if already rendered for same handles — avoid full reload flash */
      var existing = grid.querySelectorAll('[data-product-handle]');
      if (existing.length === handles.length) {
        var match = true;
        for (var i = 0; i < existing.length; i++) {
          if (handles.indexOf(existing[i].getAttribute('data-product-handle')) === -1) {
            match = false;
            break;
          }
        }
        if (match) {
          syncButtons();
          return;
        }
      }

      /* Instant paint from session cache when available */
      var cachedProducts = [];
      var missing = [];
      handles.forEach(function (h) {
        var c = cacheGet(h);
        if (c) cachedProducts.push(c);
        else missing.push(h);
      });
      if (cachedProducts.length) {
        grid.innerHTML = cachedProducts.map(cardHtml).join('') +
          (missing.length ? missing.map(function () { return skeletonCard(); }).join('') : '');
        syncButtons();
        if (!missing.length) return;
        handles = missing.concat(cachedProducts.map(function (p) { return p.handle; }));
      } else {
        grid.innerHTML = handles.map(function () { return skeletonCard(); }).join('');
      }
    }

    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (shopRoot.slice(-1) !== '/') shopRoot += '/';

    var fetchHandles = read();

    Promise.all(
      fetchHandles.map(function (h) {
        var cached = cacheGet(h);
        if (cached) return Promise.resolve(cached);
        var urls = [
          shopRoot + 'products/' + encodeURIComponent(h) + '.js',
          '/products/' + encodeURIComponent(h) + '.js'
        ];
        function tryFetch(i) {
          if (i >= urls.length) return Promise.resolve(null);
          return fetch(urls[i], { credentials: 'same-origin' })
            .then(function (r) {
              if (!r.ok) throw new Error('missing');
              return r.json();
            })
            .then(function (p) {
              cacheSet(h, p);
              return p;
            })
            .catch(function () {
              return tryFetch(i + 1);
            });
        }
        return tryFetch(0);
      })
    )
      .then(function (products) {
        if (gen !== renderGen) return;

        var valid = products.filter(Boolean);
        if (valid.length !== fetchHandles.length) {
          var validHandles = valid.map(function (p) { return p.handle; });
          write(validHandles, true);
          syncHeaderBadge();
          updateToolbar(root, validHandles.length);
        }

        if (!grid) return;

        if (!valid.length) {
          grid.innerHTML = '';
          grid.hidden = true;
          if (empty) empty.hidden = false;
          return;
        }

        grid.innerHTML = valid.map(cardHtml).join('');
        syncButtons();
      })
      .catch(function () {
        if (gen !== renderGen) return;
        if (grid) {
          grid.innerHTML =
            '<p class="ss-wishlist__error" role="alert">Could not load wishlist items. Please refresh.</p>';
        }
      });
  }

  function cardHtml(p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var price = formatMoney(p.price);
            var variant = p.variants && p.variants[0];
            var compare = '';
            if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
              compare = '<span class="ss-pcard__compare">' + formatMoney(variant.compare_at_price) + '</span>';
            }
            return (
              '<article class="ss-pcard" data-product-handle="' +
              escapeHtml(p.handle) +
              '" data-product-id="' +
              p.id +
              '">' +
              '<div class="ss-pcard__media-wrap">' +
              '<a href="/products/' +
              escapeHtml(p.handle) +
              '" class="ss-pcard__media" aria-label="' +
              escapeHtml(p.title) +
              '">' +
              (img
                ? '<img class="ss-pcard__img" src="' +
                  escapeHtml(img) +
                  '" alt="' +
                  escapeHtml(p.title) +
                  '" loading="eager" decoding="async" width="400" height="400">'
                : '<div class="ss-pcard__ph"></div>') +
              '</a>' +
              '<button type="button" class="ss-pcard__icon-btn is-saved" data-ss-wishlist aria-label="Remove from wishlist" aria-pressed="true">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
              '</button>' +
              '</div>' +
              '<div class="ss-pcard__body">' +
              (p.vendor ? '<span class="ss-pcard__brand">' + escapeHtml(p.vendor.toUpperCase()) + '</span>' : '') +
              '<h3 class="ss-pcard__title"><a href="/products/' +
              escapeHtml(p.handle) +
              '">' +
              escapeHtml(p.title) +
              '</a></h3>' +
              '<div class="ss-pcard__price-row"><span class="ss-pcard__price">' +
              price +
              '</span>' +
              compare +
              '</div>' +
              (variant && variant.available
                ? variant.id && p.variants.length === 1
                  ? '<button type="button" class="ss-pcard__cta" data-ss-quick-add data-variant-id="' +
                    variant.id +
                    '" data-product-title="' +
                    escapeHtml(p.title) +
                    '"><span class="ss-pcard__cta-label">Add to cart</span><span class="ss-pcard__cta-loading" hidden>Adding…</span><span class="ss-pcard__cta-done" hidden>Added</span></button>'
                  : '<button type="button" class="ss-pcard__cta ss-pcard__cta--options" data-ss-quick-view="' +
                    escapeHtml(p.handle) +
                    '"><span class="ss-pcard__cta-label">Choose options</span></button>'
                : '<a href="/products/' +
                  escapeHtml(p.handle) +
                  '" class="ss-pcard__cta ss-pcard__cta--sold">Sold out</a>') +
              '</div></article>'
            );
  }

  /* Sync buttons/badge on wishlist updates — do NOT re-fetch page unless needed */
  document.addEventListener('ss:wishlist-updated', function () {
    syncButtons();
  });

  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('[data-ss-wishlist-clear]');
    if (!clearBtn) return;
    if (!window.confirm('Clear your entire wishlist?')) return;
    write([]);
    renderPage();
  });

  function init() {
    syncButtons();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    syncButtons();
    renderPage();
  });

  window.ssWishlist = {
    read: read,
    toggle: toggle,
    isSaved: isSaved,
    sync: syncButtons,
    renderPage: renderPage
  };
})();
